<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialogs.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialogs.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <section>
          <v-card
            :class="dialogs.fullscreen ? 'non-border-radius' : 'border-radius'"
            class="pa-2">
            <v-card-title
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                <v-card
                  @click="$emit('back', false)"
                  flat
                  color="transparent">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="28"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="humax"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-3"
                      style="font-weight: 600;">
                     {{ items.user_name }}
                    </span>
                  </div>
                </v-card>
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialogs.fullscreen = !dialogs.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialogs.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialogs.detail = false; dialogs.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>

            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 mt-3 mb-4"
              style="height: calc(100vh - 280px); overflow-y: auto;">
              <v-row
                class="mb-4">
                <v-col
                  cols="12"
                  md="5">
                  <div>
                    <div 
                      class="body-2 mb-2">
                      Range Periode
                    </div>

                    <v-menu
                      ref="range"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker.range">
                      <template v-slot:activator="{ on, attrs }">
                        <v-card
                          v-on="on"
                          v-bind="attrs"

                          flat
                          color="#f2f2f2"
                          style="border-radius: 10px;">
                          <div
                            class="d-flex align-center"
                            style="padding: 9px;">
                            <!-- <v-icon>mdi-calendar-multiselect-outline</v-icon> -->

                            <div v-if="filter.dates.length > 0"
                              class="body-1 ml-1">
                              {{ filter.dates[0] | date_month }} - {{ filter.dates[1] | fulldate }}
                            </div>

                            <div v-else
                              class="body-1 ml-1"
                              style="opacity: 45%;">
                              Pilih Range Periode
                            </div>
                          </div>
                        </v-card>
                      </template>
                      
                      <v-date-picker 
                        range
                        :color="set_color"
                        v-model="filter.dates"
                        @input="picker.range = filter.dates.length > 1 ? false : true">
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="pr-0">
                  <div>
                    <div class="body-2 mb-2">
                      Kategori Penilaian
                    </div>

                    <v-select
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih Kategori Penilaian"

                      hide-details
                      
                      :items="master_category_score"
                      item-value="kategori_penilaian"
                      item-text="kategori_penilaian"
                      :item-color="set_color"

                      v-model="filter.kategori_penilaian"
                      required
                      style="border-radius: 10px;">
                    </v-select>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="1">
                  <div
                    class="d-flex justify-center"
                    style="margin-top: 28px;">
                    <v-btn
                      @click="fetchData()"

                      min-height="40"
                      min-width="40"
                      color="#f0f0f0"
                      elevation="0"
                      class="px-0"
                      style="border-radius: 10px;">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-simple-table
                id="table_score">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        No
                      </th>

                      <th 
                        class="black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Indikator Yang Dinilai
                      </th>

                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        colspan="2"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Sub Indikator
                      </th>

                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Bobot Sub Indikator
                      </th>

                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Bobot Indikator
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important;">1</td>
                      <td rowspan="3" style="border: 1px solid #e0e0e0 !important; border-left: 0px !important; border-top: 0px !important;">Pelaksanaan Tugas Utama</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">A. Penilaian Individu (Job Deskripsi)</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">Kesesuaian pekerjaan yang dilakukan dengan uraian pekerjaan</td>
                      <td class="text-center" style="border-bottom: 1px solid #e0e0e0 !important;">{{ data_table.bobot_individu.toFixed(2) }}</td>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important;">{{ data_table.bobot_tugas_utama.toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">B. Penilaian Atasan Langsung</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">Hasil nilai kuesioner</td>
                      <td class="text-center" style="background: #ffffff; border-bottom: 1px solid #e0e0e0 !important;">{{ data_table.bobot_atasan_langsung.toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">C. Kedisiplinan Karyawan (Presensi)</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">Jumlah Kehadiran atau presensi</td>
                      <td class="text-center" style="border-bottom: 1px solid #e0e0e0 !important;">{{ data_table.bobot_presensi.toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important; border-bottom: 0px !important; background: #ffffff;">2</td>
                      <td rowspan="3" style="border: 1px solid #e0e0e0 !important; border-left: 0px !important; border-top: 0px !important; border-bottom: 0px !important;">Penunjang (Tugas Tambahan)</td>
                      <td rowspan="3" style="border-right: 1px solid #e0e0e0 !important;">Pengembangan Diri (Objektif)</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">1. Sertifikasi Kompetensi</td>
                      <td class="text-center" style="background: #ffffff; border-bottom: 1px solid #e0e0e0 !important;">{{ data_table.bobot_sertifikasi_kompetensi.toFixed(2) }}</td>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important; border-bottom: 0px !important; background: #ffffff;">{{ data_table.bobot_tugas_tambahan.toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">2. Pelatihan dengan Sertifikat</td>
                      <td class="text-center" style="border-bottom: 1px solid #e0e0e0 !important;">{{ data_table.bobot_pelatihan_sertifikasi.toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important;">3. Keterlibatan pegawai di lingkungan sekitar</td>
                      <td class="text-center" style="background: #ffffff;">{{ data_table.bobot_keterlibatan_pegawai.toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td 
                        colspan="3" 
                        class="text-center font-weight-bold" 
                        style="border-bottom: 1px solid #e0e0e0 !important; border-left: 1px solid #e0e0e0 !important; border-right: 1px solid #fff !important;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Keterangan : 
                        
                        <span 
                          :class="data_table.bobot_total < 70 ? 'red--text' :
                                  (data_table.bobot_total >= 70 && data_table.bobot_total < 80) ? 'orange--text' :
                                  (data_table.bobot_total >= 80 && data_table.bobot_total < 90) ? 'blue--text' : 'green--text'">
                          {{ data_table.bobot_label }}
                        </span>
                      </td>
                      <td 
                        colspan="2" 
                        class="text-center font-weight-bold" 
                        style="border-bottom: 1px solid #e0e0e0 !important;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Jumlah Bobot
                      </td>
                      <td 
                        class="text-center font-weight-bold" 
                        style="border: 1px solid #e0e0e0 !important; border-left: 1px solid #fff !important;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        {{ data_table.bobot_total.toFixed(2) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <ValidationObserver 
                ref="form">
                <v-form
                  class="mt-6">
                  <ValidationProvider 
                    name="Catatan" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      Catatan
                    </div>

                    <v-textarea
                      filled
                      rounded
                      dense
                      rows="4"
                      hide-details
                      :color="set_color"
                      placeholder="Contoh. Tuliskan catatan disini . . ."

                      v-model="form.summary_note"
                      :success="form.summary_note !== '' && valid"
                      :error-messages="errors"
                      class="mb-4"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.summary_note !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                v-on:keyup.enter="save()"
                @click="save()"

                :disabled="process.form || form.user_id === ''"
                :loading="process.form"

                width="170"
                rounded
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Simpan Nilai
              </v-btn>

              <v-btn 
                @click="prints()"

                :disabled="process.print || form.user_id === ''"
                :loading="process.print"

                width="140"
                rounded
                color="blue"
                elevation="0"
                class="body-2 font-weight-bold white--text text-capitalize">
                <v-icon small class="mr-1">mdi-file-pdf-box</v-icon>

                Cetak Nilai
              </v-btn>

              <v-btn
                @click="dialogs.detail = false; dialogs.fullscreen = false;"

                :disabled="process.form || process.print"

                width="120"
                rounded
                outlined
                color="red"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                <v-icon small class="mr-1">mdi-close-circle</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    props: {
      items: {
        type: Object,
        default: {}
      },
      dialogs: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        filter: {
          dates: [
            // moment().startOf('month').format('YYYY-MM-DD'),
            // moment().endOf('month').format('YYYY-MM-DD')
          ],

          kategori_penilaian: ''
        },

        master_category_score: [],

        data_table: {
          bobot_individu: 0,
          bobot_tugas_utama: 0,
          bobot_atasan_langsung: 0,
          bobot_presensi: 0,
          bobot_sertifikasi_kompetensi: 0,
          bobot_tugas_tambahan: 0,
          bobot_pelatihan_sertifikasi: 0,
          bobot_keterlibatan_pegawai: 0,
          bobot_total: 0,
          bobot_label: '-'
        },

        form: {
          user_id: '',
          year: '',
          summary_note: '',
          start_date: '',
          end_date: '',
          kategori_penilaian: '',
          nilai_tugas_utama: '',
          nilai_pengembangan_diri: '',
          nilai_total: '',
          desc: ''
        },
      
        picker: {
          range: false
        },

        process: {
          load: false,

          form: false,

          print: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb < 10 ? `0${numb}`.toString() : numb.toString()

        return [
          {
            text: 'Januari',
            value: '01'
          },
          {
            text: 'Februari',
            value: '02'
          },
          {
            text: 'Maret',
            value: '03'
          },
          {
            text: 'April',
            value: '04'
          },
          {
            text: 'Mei',
            value: '05'
          },
          {
            text: 'Juni',
            value: '06'
          },
          {
            text: 'Juli',
            value: '07'
          },
          {
            text: 'Agustus',
            value: '08'
          },
          {
            text: 'September',
            value: '09'
          },
          {
            text: 'Oktober',
            value: '10'
          },
          {
            text: 'November',
            value: '11'
          },
          {
            text: 'Desember',
            value: '12'
          }
        ]
      },
      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      this.fetchCategoryScore()
    },
    methods: {
      fetch () {
        this.fetchData()
        this.fetchCategoryScore()
      },

      async fetchData () {
        this.process.load = true

        let params = {
          user_id: this.items.user_id,

          start_date: this.filter.dates.length > 0 ? this.filter.dates[0] : '',
          end_date: this.filter.dates.length > 0 ? this.filter.dates[1] : '',
          
          kategori_penilaian: this.filter.kategori_penilaian
        }

        await get(`kpi/score_summary/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            let data = res.results.data
            
            if (data.length > 0) {
              this.data_table = data[0]

              this.form = {
                user_id: data[0].user_id,
                year: this.filter.dates.length > 0 ? this.filter.dates[0].split('-')[0] : '',
                summary_note: data[0].summary_note,
                start_date: this.filter.dates.length > 0 ? this.filter.dates[0] : '',
                end_date: this.filter.dates.length > 0 ? this.filter.dates[1] : '',
                kategori_penilaian: this.filter.kategori_penilaian,
                nilai_tugas_utama: data[0].bobot_tugas_utama,
                nilai_pengembangan_diri: data[0].bobot_tugas_tambahan,
                nilai_total: data[0].bobot_total.toFixed(2),
                desc: data[0].bobot_label
              }
            } else {
              this.data_table = {
                bobot_individu: 0,
                bobot_tugas_utama: 0,
                bobot_atasan_langsung: 0,
                bobot_presensi: 0,
                bobot_sertifikasi_kompetensi: 0,
                bobot_tugas_tambahan: 0,
                bobot_pelatihan_sertifikasi: 0,
                bobot_keterlibatan_pegawai: 0,
                bobot_total: 0,
                bobot_label: '-'
              }

              this.form = {
                user_id: '',
                year: '',
                summary_note: '',
                start_date: '',
                end_date: '',
                kategori_penilaian: '',
                nilai_tugas_utama: '',
                nilai_pengembangan_diri: '',
                nilai_total: '',
                desc: ''
              }
            }
          }
        })
      },

      async fetchCategoryScore () {
        let params = {
          limit: 100000
        }

        await get('admin/kategori_penilaian/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.master_category_score = res.results.data
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post('kpi/score_summary/update_note', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialogs.detail = false

              // this.dialogs.snackbar = true
              // this.message.success = res.message

              this.$emit('messages', 'ini message')

              this.dialogs.fullscreen = false

              this.$emit('refresh', true)
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          user_id: this.items.user_id,

          start_date: this.filter.dates.length > 0 ? this.filter.dates[0] : '',
          end_date: this.filter.dates.length > 0 ? this.filter.dates[1] : '',

          kategori_penilaian: this.filter.kategori_penilaian
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}kpi/score_summary/print_PDF`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.print = false

          if (res.status === 200) {
            
            this.dialogs.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)

            document.body.appendChild(link)
            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>